// @ts-nocheck
import React, { Component, Suspense } from 'react'
import { connect } from 'react-redux'
import { find, get } from 'lodash'
import PopupModal from './PopupModal'
import Modal from '.'
import Field from '../fields'
import Operations from '../../operations'

type AddStockLogModalProps = {
  createItem: (options: any) => void
  fields: any
  updateListItem: (options: any) => void
  loadListItem: (list: string, item: any, query: any) => void
  medication: any
  isOpen: boolean
  preferredPeopleNominative: any
  role: string
}

export class AddStockLogModal extends Component<AddStockLogModalProps> {
  handleSubmit = (): void => {
    const { createItem, fields, updateListItem, loadListItem } = this.props
    createItem({
      json: fields,
      url: 'list/logs',
      onComplete: async (newLog) => {
        await updateListItem({
          listId: 'emar-resident-medications',
          itemId: fields.emarResidentMedication,
          successMsg: 'Added a Stock Count',
          json: {
            stockLog: newLog.id
          }
        })
        await loadListItem(
          'emar-resident-medications',
          fields.emarResidentMedication,
          { stock: true }
        )
        await loadListItem('logs', newLog.id)
      }
    })
  }

  render(): React.ReactNode {
    const {
      medication,
      fields,
      isOpen,
      preferredPeopleNominative,
      role,
      ...formProps
    } = this.props
    if (!fields || !isOpen) return null

    return (
      <PopupModal
        confirmText="Add"
        title="Add Stock Count"
        buttonIcon="PlusOutlined"
        buttonColour="success"
        list="Stock Count"
        includesRequired
        onConfirm={this.handleSubmit}
        type="create"
        {...formProps}
      >
        <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="timeLogged"
              layout="column"
              label="Date"
              type="datetime"
              values={{
                timeLogged: new Date()
              }}
            />
          </Suspense>
        </div>
        <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              id="form-title"
              formId={MODAL_ID}
              keys="title"
              label="Title"
              layout="column"
              required
              type="text"
              values={fields}
            />
          </Suspense>
        </div>
        <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              id="form-description"
              formId={MODAL_ID}
              keys="description"
              label="Description"
              layout="column"
              required
              type="textarea"
              values={fields}
            />
          </Suspense>
        </div>
        <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="amount1"
              label={`Stock Count ${
                medication && medication.stockQuantityType
                  ? `(${medication.stockQuantityType})`
                  : ''
              }`}
              required
              layout="column"
              type="number"
              values={fields}
            />
          </Suspense>
        </div>
        <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="amount2"
              label={`Expected Stock Count ${
                medication && medication.stockQuantityType
                  ? `(${medication.stockQuantityType})`
                  : ''
              }`}
              layout="column"
              type="number"
              values={fields}
            />
          </Suspense>
        </div>
      </PopupModal>
    )
  }
}

const styles = {
  fieldContainer: {
    marginBottom: 20
  }
}

const MODAL_ID = 'addStockLog'

const mapStateToProps = (state: any, props: any) => ({
  medication: find(state.data['emar-resident-medications'], {
    id: get(props, 'initial.emarResidentMedication')
  })
})

const mapDispatchToProps = (dispatch: any) => ({
  loadListItem: (list: string, item: any, query: any) =>
    dispatch(Operations.loadListItem(list, item, query)),
  updateListItem: (options: any) => dispatch(Operations.updateListItem(options))
})

const wrappedModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddStockLogModal)

export default Modal(wrappedModal, MODAL_ID)
